import React from 'react';
import { useForm, FieldValues } from 'react-hook-form';

import {
  InputEmail,
  InputText,
  InputPassword,
  ErrorField,
} from '../../../lib/HooksFormFields';

import styles from './register-form.module.scss';

interface IRegisterForm {
  errorMessage?: string,
  registerLink?: string,
  forgotPwdLink?: string,
  textSubmit?: string,
  submit: (data: FieldValues) => void,
}

export interface CredentialsRequest {
  email: string
  password: string
}

const RegisterForm = ({
  errorMessage,
  textSubmit,
  submit,
}: IRegisterForm) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  function onSubmit(data: FieldValues) {
    submit(data as CredentialsRequest);
  }

  function handlePressEnter(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      handleSubmit(onSubmit)();
    }
  }

  return (
    <div className={styles['register-form']}>
      <div className={styles.form} onKeyDown={handlePressEnter}>
        <div className={styles.containerField}>
          <InputText
            name="firstName"
            control={control}
            label="Prénom"
            className="login"
            rules={{
              required: 'Ce champs est obligatoire',
            }}
          />
          {errors.firstName && <ErrorField message={errors.firstName.message} />}
        </div>
        <div className={styles.containerField}>
          <InputText
            name="lastName"
            control={control}
            label="Nom"
            className="login"
            rules={{
              required: 'Ce champs est obligatoire',
            }}
          />
          {errors.lastName && <ErrorField message={errors.lastName.message} />}
        </div>
        <div className={styles.containerField}>
          <InputEmail
            name="email"
            control={control}
            required
            label="Adresse mail"
            placeholder='adressemail@mail.fr'
            className="login"
          />
          {errors.email && <ErrorField message={errors.email.message} />}
        </div>
        <div className={styles.containerField}>
          <InputPassword
            name="password"
            control={control}
            required
            requiredMessage="Veuillez saisir votre mot de passe"
            label="Mot de passe"
            placeholder='**********'
            className="login"
          />
          {errors.password && <ErrorField message={errors.password.message} />}
        </div>
      </div>
      <div className={styles.containerSubmit}>

        {(!errors.email && !errors.password) && errorMessage
          && (
            <div className={styles.error}>
              <ErrorField message={errorMessage} />
            </div>
          )}
        <div className={styles.containerBtn}>
          <button className={'secondary'} onClick={handleSubmit(onSubmit)}>
            <span>{textSubmit || 'Connexion'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
